import gql from 'graphql-tag';

const CANCEL_QUEUED_PRICE_CHANGE = gql`
	mutation cancelQueuedPriceChange ($id: ID!) {
		cancelQueuedPriceChange(id: $id) {
			id
			price
			queuedPrice
			queuedPriceType
		}
	}
`;

export default CANCEL_QUEUED_PRICE_CHANGE;

